/* One policy destination per topic, shared with the NORGIRA footer. */
(() => {
  const destinations = {
    'shipping-policy': '/pages/shipping-and-delivery',
    'refund-policy': '/pages/returns',
    'return-policy': '/pages/returns',
    'privacy-policy': '/pages/privacy-policy',
    'terms-of-service': '/pages/terms-of-use',
    'terms-of-use': '/pages/terms-of-use',
    'terms-and-conditions': '/pages/terms-of-use',
    'contact-information': '/pages/contact'
  };
  const checkoutPolicies = {
    '53218705725': destinations['privacy-policy'],
    '55214211389': destinations['refund-policy'],
    '55214244157': destinations['shipping-policy'],
    '55214276925': destinations['terms-of-service'],
    '55265755453': destinations['contact-information']
  };
  function destination(href) {
    if (!href || href.startsWith('#')) return null;
    let url;
    try { url = new URL(href, location.href); } catch (_) { return null; }
    if (url.hostname === 'checkout.shopify.com') {
      const match = url.pathname.match(/^\/99849044285\/policies\/(\d+)\.html$/);
      return match ? checkoutPolicies[match[1]] || null : null;
    }
    if (![location.hostname, 'norgira.cc', 'www.norgira.cc', 'norgira.myshopify.com'].includes(url.hostname)) return null;
    const match = url.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:policies|pages)\/([^/]+)\/?$/i);
    if (!match || !destinations[match[2]]) return null;
    const target = `${match[1] || ''}${destinations[match[2]]}`;
    return url.pathname === target ? null : `${target}${url.search}`;
  }
  function normalize(root) {
    const anchors = root.matches?.('a[href]') ? [root] : [];
    if (root.querySelectorAll) anchors.push(...root.querySelectorAll('a[href]'));
    anchors.forEach(anchor => { const target = destination(anchor.getAttribute('href')); if (target) anchor.setAttribute('href', target); });
  }
  const currentDestination = destination(location.href);
  if (currentDestination && /\/policies\//.test(location.pathname)) {
    location.replace(currentDestination);
    return;
  }
  normalize(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') normalize(record.target);
    else record.addedNodes.forEach(node => { if (node.nodeType === 1) normalize(node); });
  })).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
})();
